import { effectiveSellerPrice, type PriceSellerData } from '@/components/client/product/prices/price-section-types'
import { cmpBest, POSITION_SENTINEL } from '@/lib/prices/select'

/** Keep the caption and deal tied to the same preferred offer for the selection. */
export const preferredScorecardOffer = (sellers: PriceSellerData[]) =>
  sellers
    .filter((seller) => seller.url)
    .sort((a, b) =>
      cmpBest(
        {
          sellerPosition: a.sellerPosition ?? POSITION_SENTINEL,
          discountPrice: a.price > 0 ? effectiveSellerPrice(a) : Infinity,
        },
        {
          sellerPosition: b.sellerPosition ?? POSITION_SENTINEL,
          discountPrice: b.price > 0 ? effectiveSellerPrice(b) : Infinity,
        }
      )
    )[0]
